const genders = Object.freeze([
    Object.freeze({
        text: "Male",
        value: "MALE"
    }),
    Object.freeze({
        text: "Female",
        value: "FEMALE"
    }),
    Object.freeze({
        text: "Unspecified",
        value: "UNSPECIFIED"
    })
]);

export default genders;
